export namespace auth {
    export enum Roles {
        Admin = "admin",
        Organizations = "organizations",
        Visitor = "visitor"
    }

    export enum AclAccess {
        Analytics = "analytics:access",
        Documentation = "documentation:access",
        Loki = "loki:access",
        Organization = "organization:access",
        OrganizationAuthorization = "organization:authorization:access",
        Sales = "sales:access",
        SalesFuture = "sales:future:access",
        SaleCreate = "sale:create",
        Search = "search:access",
        Temis = "temis:access"
    }

    export enum Scopes {
        BA_ACCESS = "ba_access",
        PAYOUTS = "payouts",
        ORGANIZATION_ADMIN = "organization_admin",
        ORGANIZATION_CLIENT_INFORMATIONS = "organization_clients_informations",
        ORGANIZATION_SETTINGS = "organization_settings",
        STATS_ACTIVITY = "organization_statistics"
    }

    export interface JwtAccessToken {
        iat: number;
        exp: number;
        organizationId: number;
        firstname: string;
        lastname: string;
        device: string;
        deviceId: string;
        role: string;
        rights: Rights[];
    }
    export interface Rights {
        id: string;
        scopes: Scopes[];
        condition: {
            entity: string;
            id: number;
        };
    }

    export type HasRights = {
        [scope in Scopes]?: boolean;
    };
}
